/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import _debounce from "lodash.debounce";
import { RegionsList } from "../../../Teams/RegionsList/regions-list";
import { TeamCount } from "../../../Teams/TeamCount/team-count";
import { Team } from "../../../Teams/teams";
import { Globe3d } from "./globe/globe";
import "./styles.scss";

interface GlobeProps {
  teams: Team[];
}

export const Globe = (props: GlobeProps): JSX.Element => {
  const history = useHistory();
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState<boolean>(width < 750);
  useEffect(() => {
    if (window.innerWidth <= 750 && !isMobile) {
      setIsMobile(true);
    } else if (window.innerWidth > 750 && isMobile) {
      setIsMobile(false);
    }
  }, [width]);
  useEffect(() => {
    const handleResize = _debounce(() => setWidth(window.innerWidth), 100);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });
  return (
    <div className="globe">
      <div className="globe-wrapper">
        <div className="dome" />
        <div className="globe-title-wrapper">
          <h1>
            Explore iGEM Teams
            <br />
            <span>around the world</span>
          </h1>
          <div className="globe-legend">
            <div className="globe-legend-item">
        <div style={ {backgroundColor: "#40cc7f"}}/>
              <p>2021 teams</p>
            </div>
            <div className="globe-legend-item">
              <div style={ {backgroundColor: "#ed5757"}}/>
              <p>Ambassadors</p>
            </div>
          </div>
        </div>
        {isMobile && <TeamCount countFallback={props.teams.length} />}
        <div className="globe-model-wrapper">
          <Globe3d teams={props.teams} />
          <div className="globe-teams-info">
            {!isMobile && <TeamCount countFallback={props.teams.length} />}
            <RegionsList />
            <button
              type="button"
              className="globe-teams-info-link"
              onClick={() => {
                history.push("/teams");
              }}
            >
              <Link to="/teams">
                <h6>Team List</h6>
              </Link>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
